import { render, staticRenderFns } from "./DownloadTemplateSelect.vue?vue&type=template&id=3611b496&"
import script from "./DownloadTemplateSelect.vue?vue&type=script&lang=ts&"
export * from "./DownloadTemplateSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadTemplateSelect.vue?vue&type=style&index=0&id=3611b496&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports